<template>
  <div class="overlayWrapper" @click="onClickOverlay">
    <CardLarge class="partyOverlay">
      <div class="closeWrapper">
        <font-awesome-icon
          icon="fa-solid fa-circle-xmark"
          class="close"
          @click="closePartyOverlay()"
        />
      </div>

      <header>
        <img class="logo" :src="`images/parties/${party.logo}`" />
        <ProgressBar
          :showPartyInfo="true"
          :partyId="partyId"
          :value="affinity"
          :total="totalStatements"
        >
          {{ affinity }} / {{ totalStatements }}
        </ProgressBar>
      </header>

      <section class="description">
        <p>{{ party.description }}</p>
      </section>

      <section class="themes">
        <div class="title">
          <h2>{{ themeLabel }}</h2>
        </div>

        <ProgressBar
          v-for="theme in affinityThemes"
          :key="theme.theme"
          :showPartyInfo="false"
          :label="theme.theme"
          :value="theme.affinity"
          :total="theme.total"
        />
      </section>

      <section class="person">
        <div class="title">
          <h2>{{ party.imageTitle }}</h2>
          <h3>{{ party.imageSubtitle }}</h3>
        </div>
        <div class="imageWrapper">
          <a :href="party.imageLink" target="_blank">
            <img :src="party.image" />
          </a>
        </div>
      </section>

      <section class="links">
        <CTA v-if="party.website" :href="party.website" target="_blank" label="Partijwebsite" />
        <CTA
          v-if="party.websiteYouth"
          :href="party.websiteYouth"
          target="_blank"
          label="Website jongerenorganisatie"
        />
        <CTA
          v-if="party.instagram"
          :href="party.instagram"
          target="_blank"
          :label="`Instagram van ${party.name}`"
        />
        <CTA
          v-if="party.twitter"
          :href="party.twitter"
          target="_blank"
          :label="`X (Twitter) van ${party.name}`"
        />
      </section>
    </CardLarge>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CardLarge from "@/components/Layout/CardLarge.vue";
import ProgressBar from "@/components/UI/ProgressBar";
import CTA from "@/components/UI/CTA";

export default {
  name: "Party",

  components: {
    CardLarge,
    ProgressBar,
    CTA,
  },

  computed: {
    ...mapGetters([
      "getPartyById",
      "getAffinityById",
      "getResultsByPartyId",
      "getStatementIdsByTheme",
    ]),

    ...mapState({
      selectedThemes: (state) => state.selectedThemes,
      totalStatements: (state) => state.totalStatements,
      themeLabel: (state) => state.dictionary.themes.similar
    }),

    partyId() {
      return parseInt(this.$route.params.partyId);
    },

    party() {
      return this.getPartyById(this.partyId);
    },

    results() {
      return this.getResultsByPartyId(this.partyId);
    },

    affinity() {
      return this.getAffinityById(this.partyId);
    },

    affinityThemes() {
      const affinityThemes = [];

      this.selectedThemes.forEach((theme) => {
        const ids = this.getStatementIdsByTheme(theme);
        const statements = this.results.affinity.filter((statement) =>
          ids.includes(statement.statementId)
        );

        affinityThemes.push({
          theme: theme,
          total: ids.length,
          affinity: statements.length,
        });
      });

      affinityThemes.sort((a, b) => b.affinity - a.affinity);
      return affinityThemes;
    },
  },

  methods: {
    closePartyOverlay() {
      this.$router.push({ name: "results" });
    },

    // close overlay when clicking outside of the card
    onClickOverlay(e) {
      if (e.target === this.$el) {
        this.closePartyOverlay();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayWrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  overflow-y: auto;
  overflow-x: hidden;
  top: 0;
  left: 0;
}

.partyOverlay {
  color: $blue;
  text-align: left;
  margin: 50px auto 20px;
  position: relative;

  @include media("<=phone") {
    padding: 0 25px 25px;
  }

  @include media(">phone") {
    padding: 0 50px 50px;
  }
}

img {
  width: 100%;
  height: auto;
  display: block;
}

.title {
  margin-bottom: 1em;
}

header {
  text-align: center;
}

header,
section {
  &:not(:last-child) {
    @include media("<=phone") {
      margin-bottom: 25px;
    }

    @include media(">phone") {
      margin-bottom: 50px;
    }
  }
}

h2 {
  @include type-strong;
}

.logo {
  max-width: 230px;
  margin: 0 auto;
  padding: 25px 0;
  object-fit: contain;
  aspect-ratio: 1/1.2;
}

.imageWrapper {
  border-radius: $border-radius;
  overflow: hidden;
}

.closeWrapper {
  position: sticky;
  left: 100%;
  top: 20px;
  width: 32px;
  height: 32px;
  z-index: 100;
  background: white;
  border-radius: 32px;
  margin-top: 20px;
}

.close {
  font-size: 32px;
  color: $pink;
  cursor: pointer;
}
</style>
